import { Grid, Typography } from '@mui/material';
import { LegalProceedingsProductProps } from './props';
import { useLegalProceedingsProduct } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const LegalProceedingsProduct = (
    props: LegalProceedingsProductProps
) => {
    const { formik, products } = useLegalProceedingsProduct(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Producto
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(products)}
                    label="Ramo"
                    name="bouquet"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.bouquet}
                    errors={formik.errors.bouquet}
                    value={formik.values.bouquet}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('bouquet', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
